import { render } from "./CambiaPassword.vue?vue&type=template&id=433a730e"
import script from "./CambiaPassword.vue?vue&type=script&lang=js"
export * from "./CambiaPassword.vue?vue&type=script&lang=js"

import "./CambiaPassword.vue?vue&type=style&index=0&id=433a730e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__